import { withInstall } from '@element-plus/utils/with-install'

import Divider from './src/divider.vue'

export const ElDivider = withInstall(Divider)
export default ElDivider

export * from './src/divider'
